export default "__VITE_ASSET__7GUsw6$w__"